import back from 'assets/images/eventBoatRacingT10/back.png'

export default function ButtonBack({ handleNextPage }) {
	return (
		<div onClick={handleNextPage} className='button-back' >
			<img src={back} alt="img-button-back" className="button-back" />
		</div>
	)
}
